
import { baseApi } from "./baseAPI";
import { Customer, NewCustomer } from "../dtos/customer/customer";

export const customerApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCustomers: build.query<Customer[], {query: string, includeDeleted: boolean}>({
            query: ({query, includeDeleted}) => {
                return `Customers?query=${query}&includeDeleted=${includeDeleted}`
            },
            providesTags:() => [{type: 'Customers', value: "LIST"}],

        }),
        getAllCustomers: build.query<Customer[], {query: string, includeDeleted: boolean}>({
            query: ({query, includeDeleted}) => {
                return `Customers/all?query=${query}&includeDeleted=${includeDeleted}`
            },
            providesTags:() => [{type: 'Customers', value: "LIST"}],

        }),
        addCustomer: build.mutation<Customer, Customer | NewCustomer>({
            query: (body) => ({
                url: `Customers`,
                method: 'POST',
                body,
            }),
            invalidatesTags: (isUpdated) => [{type: 'Customers', value:'LIST'}]
        }),
        deactivateCustomer: build.mutation<{message: string}, {id: number}>({
            query(id) {
                return {
                    url: `customers/${id}/disable`,
                    method: 'POST',
                }
            },
            invalidatesTags: (isUpdated) => [{type: 'Customers', value:'LIST'}]
        }),
        activateCustomer: build.mutation<void,{id: number}>({
            query: (id) => ({
                url: `customers/${id}/enable`,
                method: 'POST',
                body:{}
        }),
        invalidatesTags: (isUpdated) => [{type: 'Customers', value:'LIST'}]
    }),
    }),
    overrideExisting: false,
})

export const {
    useGetCustomersQuery,
    useGetAllCustomersQuery,
    useAddCustomerMutation,
    useDeactivateCustomerMutation,
    useActivateCustomerMutation
} = customerApi
